import type { DemoData } from '../../demo-data';
import { seedPharmacyEpisodes } from './pharmacy-episodes.fixture';
import { seedHealthSummary } from '../patient.fixture';
import {
  seedPharmacyCareSignals,
  seedPharmacyMedicationItems,
  seedPharmacyStoryEntries,
} from './pharmacy-timeline.fixture';

/**
 * The parts of the demo data that differ in the pharmacy perspective. Built inside the call, never
 * as module constants, so the perspective is read when the store seeds, not when the module loads.
 */
export function seedPharmacyStory(): Pick<
  DemoData,
  'healthSummary' | 'storyEntries' | 'careSignals' | 'episodes'
> {
  return {
    healthSummary: seedHealthSummary(seedPharmacyMedicationItems()),
    storyEntries: seedPharmacyStoryEntries(),
    careSignals: seedPharmacyCareSignals(),
    episodes: seedPharmacyEpisodes(),
  };
}
